import React from 'react';
import BaseClass from '@/pages/BaseClass';

import {
	Form,
	Input,
	Button,
	Select,
	List,
	Radio,
	Card,
	Cascader,
	Switch,
	Popconfirm,
	Modal,
	Divider,
} from 'antd'
import $ from 'jquery';
import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	httpPost
} from '@/utils/Tools';

export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'mode':'main',
			'provinceList':[],
			'addressList':[],
			'info':{
				'address_id':0,
			},
			
			'rules':{
				'consignee':[
					{
						required: true,
						message: '请输入收货人姓名',
					},
				],
				'phone':[
					{
						required: true,
						message: '请输入联系电话',
					},
				],
				'area_info':[
					{
						required: true,
						message: '请选择地区',
					},
					{
						validator: (rule,value)=>{
							if(!Array.isArray(value) || !value.length)
								return Promise.reject(new Error('请选择所在地区'));
							
							if(value.length != 3)
							{
								let find = this.state.provinceList.find(row=>{
									return row.value == value[0];
								});
								if( value.length == 1)
								{
									
									if(find.children.length)
										return Promise.reject(new Error('请选择所在城市信息'));
								}
								else if(value.length == 2)
								{
									let find1 = find.children.find(row=>{
										return row.value == value[1];
									});
									if(find1.children.length)
										return Promise.reject(new Error('请选择所在地区信息'));
								}
							}
							return Promise.resolve();
						},
					},
				],
				'address':[
					{
						required: true,
						message: '请输入详细地址',
					},
				],
			},
			'showAddressDialog':false,

			'showInfoDialog':false,
		};
	}
	
	componentDidMount()
	{
		this.getAddressList();
		this.getAreaList(0)
			.then(data=>{
				data.forEach(row=>{
					row.children = [];
					row.isLeaf = false;
				});
				this.setState({
					'provinceList':data,
				});
			});
	}
	
	getAddressList()
	{
		let url = pcUrl('address','index');
		let param = {
			'page_size':0
		};
		httpPost(url,param)
			.then(data=>{
				let find = data['list'].find(row=>+row['is_default']);
				if(!find)
					find = data['list'][0];
				let info = this.state.info;
				info['address_id'] = find['address_id'];
					
				this.setState({
					'info':info,
					'addressList':data['list']
				});
			});
	}
	getCompanyInfo()
	{
		let url = pcUrl('user','companyInfo');
		httpPost(url)
			.then(data=>{
				this._setAddressInfo({
					'consignee':'',
					'phone':this.state.userInfo['user_name'],
					'province_id':data['province_id'],
					'city_id':data['city_id'],
					'area_id':data['area_id'],
					'address':data['address'],
				});
			});
	}
	
	showAddress()
	{
		let info = this.state.info;
		let defaultAddress = this.state.addressList.find(row=>+row['is_default']);
		if(defaultAddress)
			info['address_id'] = defaultAddress['address_id'];
		this.setState({
			'info':info,
			'showAddressDialog':true,
		});
	}
	
	selectAddress()
	{
		let url = pcUrl('address','save');
		let param = {
			'address_id':this.state.info['address_id'],
			'is_default':1,
		};
		httpPost(url,param)
			.then(()=>{
				this.setState({
					'showAddressDialog':false,
				});
				this.getAddressList();
			});
	}
	
	add()
	{
		this.setState({
			'mode':'add',
			'showInfoDialog':true,
		},()=>{
			this.mainForm.resetFields();
			this.mainForm.setFieldsValue({
				'is_default':0
			});
			
			if(!this.state.addressList.length)
				this.getCompanyInfo();
		});
	}
	
	show(index)
	{
		this.setState({
			'showInfoDialog':true,
			'mode':'edit',
		},()=>{
			let info = this.state.addressList[index];
			this._setAddressInfo(info);
		});
	}
	
	delete(index)
	{
		let info = this.state.addressList[index];
		
		let url = pcUrl('address','delete');
		let param = {
			'address_id':info['address_id']
		};
		httpPost(url,param)
			.then(()=>{
				message('收货地址删除成功','success');
				this.getAddressList();
			});
	}
	
	_setAddressInfo(data)
	{
		let addressInfo = {
			'address_id':data['address_id'] || 0,
			'consignee':data['consignee'],
			'phone':data['phone'],
			'area_info':[data['province_id'],data['city_id'],data['area_id']],
			'address':data['address'],
			'is_default':+data['is_default']
		};
		for(let key in addressInfo)
			this.mainForm.setFieldsValue(addressInfo);
		this.getAreaList(0)
			.then(data=>{
				data.forEach(row=>{
					row.children = [];
					row.isLeaf = false;
				});
				this.setState({
					'provinceList':data,
				});
				if(addressInfo['area_info'][0])
				{
					let provinceId = addressInfo['area_info'][0];
					this.getAreaList(provinceId)
						.then(data=>{
							data.forEach(row=>{
								row.children = [];
								row.isLeaf = false;
							});
							let provinceInfo = this.state.provinceList.find(row1=>row1.value == provinceId);
							provinceInfo.children = data;
							this.setState({
								'provinceList':[...this.state.provinceList],
							});

							if(addressInfo['area_info'][1])
							{
								let cityId = addressInfo['area_info'][1];
								this.getAreaList(cityId)
									.then(data=>{
										let cityInfo = provinceInfo.children.find(row2=>row2.value == cityId)
										cityInfo.children = data;
										this.setState({
											'provinceList':[...this.state.provinceList],
										});
									});
							}
						});
				}

			});
	}
	
	loadAreaData(data)
	{
		let lastData = data[data.length - 1];
		if(lastData.children && lastData.children.length) return;
		
		lastData.loading = true;
		this.getAreaList(lastData.value)
			.then(data1=>{
				if(data1.length)
				{
					data1.forEach(row=>{
						if(data.length == 1)
						{
							row.children = [];
							row.isLeaf = false;
						}
					});
					lastData.children = data1;
				}
				else
				{
					lastData.isLeaf = true;
				}
				lastData.loading = false;
				this.setState({
					'provinceList':[...this.state.provinceList],
				});
			});
	}
	
	getAreaList(parentId)
	{
		if(!parentId) parentId = 0;
		
		let url =pcUrl('index','areaList');
		let param = {
			'parent_id':parentId,
		};
		
		return new Promise((resolve,reject)=>{
			httpPost(url,param)
				.then(data=>{
					//转换data
					data = data.map(row=>{
						return {
							'label':row['area_name'],
							'value':row['area_id'],
						};
					});
					
					resolve(data);
				});
		});
	}
	
	submit()
	{
		this.mainForm.validateFields()
			.then(info=>{
				//获取地区信息
				info['province_id'] = info['area_info'][0];
				info['city_id'] = info['area_info'][1] || 0;
				info['area_id'] = info['area_info'][2] || 0;
				info['area_info'] = [];
				this.state.provinceList.some(row=>{
					if(row.value == info['province_id'])
					{
						info['area_info'].push(row.label);
						info['city_id'] && row.children.some(row1=>{
							if(row1.value == info['city_id'])
							{
								info['area_info'].push(row1.label);
								info['area_id'] && row1.children.some(row2=>{
									if(row2.value == info['area_id'])
									{
										info['area_info'].push(row2.label);
										return true;
									}
								});
								return true;
							}
						});
						return true;
					}
				});
				info['area_info'] = info['area_info'].join(' ');
				let url = pcUrl('address','save');
				let param = info;
				httpPost(url,param)
					.then(()=>{
						if(!info['address_id'])
							message('收货地址新增成功','success');
						else
							message('收货地址编辑成功','success');
						
						this.getAddressList();
						this.setState({
							'showInfoDialog':false,
						});
					});
			})
			.catch(()=>{
				this.focusError(1);
			});
	}
	
	getAddressId()
	{
		return this.state.info['address_id'];
	}
	
	render()
	{
		return (
			<div>
				<Divider>地址信息</Divider>
				<div style={{'border':'1px solid #EEE','padding':'1em 1.5em','backgroundColor':'white'}}>
					<span className="float-right">
						<a href="javascript:;" className="text-blue" onClick={()=>this.showAddress()}>
							使用其他地址
						</a>
					</span>
					{this.state.addressList.filter(row=>+row['is_default']).map((row,index)=>(
						`${row['consignee']} - ${row['area_info']} - ${row['address']}`
					))}
				</div>
				<Modal
					title="选择收货地址"
					width={800}
					visible={this.state.showAddressDialog}
					onOk={()=>this.selectAddress()}
					onCancel={()=>this.setState({'showAddressDialog':false})}
					>
						<Card title="" extra={<a href="javascript:;" className="text-blue" onClick={()=>this.add()}>使用新地址</a>}>
							<List>
								{this.state.addressList.map((row,index)=>(
								<List.Item actions={[
									<a href="javascript:;" className="text-blue" onClick={()=>this.show(index)}>编辑</a>,
									<Popconfirm title="确认删除该记录吗?" onConfirm={()=>this.delete(index)} onCancel={()=>{}} >
										<a href="javascript:;" className="text-red">删除</a>
									</Popconfirm>
								]}>
										<Radio.Group value={this.state.info['address_id']} onChange={e=>{let info = this.state.info; info['address_id'] = e.target.value; this.setState({'info':info})}}>
											<Radio name="company_id" value={row['address_id']} >{`${row['consignee']} - ${row['area_info']} - ${row['address']}`}</Radio>
										</Radio.Group>
									</List.Item>
								))}
							</List>
						</Card>
				</Modal>
				<Modal
					title={(this.state.mode == 'add' ? '新增':'编辑') + "收货地址"}
					width={550}
					visible={this.state.showInfoDialog}
					onOk={()=>this.submit()}
					onCancel={()=>this.setState({'showInfoDialog':false})}
					>
						<Form
							labelCol={{ span:4 }}
							wrapperCol={{ span:20 }}
							onFinish={(data)=>this.submit(data)}
							onFinishFailed={data=>this.focusError(data)}
							ref={e=>this.mainForm = e}>
							<Form.Item name="address_id" hidden> </Form.Item>
							<Form.Item name="consignee" label="收货人姓名" rules={this.state.rules['consignee']}>
								<Input />
							</Form.Item>
							<Form.Item name="phone" label="联系电话" rules={this.state.rules['phone']}>
								<Input />
							</Form.Item>
							<Form.Item name="area_info" label="所在地区" rules={this.state.rules['area_info']}>
								<Cascader options={this.state.provinceList} loadData={e=>this.loadAreaData(e)} changeOnSelect placeholder="请选择地区" />
							</Form.Item>
							<Form.Item name="address" label="详细地址" rules={this.state.rules['address']}>
								<Input.TextArea rows={5}/>
							</Form.Item>
							<Form.Item name="is_default" label="默认地址">
								<Form.Item noStyle shouldUpdate>
									{()=>(
										<Switch checked={this.mainForm && this.mainForm.getFieldValue('is_default')} onChange={val => this.mainForm && this.mainForm.setFieldsValue({'is_default':val?1:0})} />
									)}
								</Form.Item>
							</Form.Item>
							{/*
							<Form.Item shouldUpdate label="营业执照">
								{()=>JSON.stringify(this.mainForm && this.mainForm.getFieldsValue())}
							</Form.Item>
							*/}
						</Form>
				</Modal>
			</div>
		);
	}
}

